<template>
  <base-modal ref="modal" size="md">
    <base-card shadow>
      <div>
        <div class="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
          <alert-icon class="h-6 w-6 text-red-600" />
        </div>
        <div class="mt-3 text-center sm:mt-5">
          <h3 class="text-lg leading-6 font-thin text-gray-900">
            {{ title }}
          </h3>
          <div class="mt-2">
            <p class="text-sm font-thin text-gray-500">
              {{ message }}
            </p>
            <p v-if="errorMessage" class="mt-3 py-2.5 px-4 sm:py-4 sm:px-6 text-sm font-thin text-red-600 bg-red-100 rounded-md text-left">
              {{ errorMessage }}
            </p>
          </div>
          <div class="mt-4">
            <base-button color="red" type="flat" @click="hide">Dismiss</base-button>
          </div>
        </div>
      </div>
    </base-card>
  </base-modal>
</template>

<script>
import { AlertIcon } from "@/assets/svgs";
import errormessage from "@/mixins/errormessage";

export default {
  mixins: [errormessage],
  components: {
    AlertIcon,
  },
  data() {
    return {
      title: null,
      message: null,
      error: null,
      showDetails: true,
    };
  },
  computed: {
    errorMessage() {
      return this.error ? this.getErrorMessage(this.error) : "No Details Available :(";
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
  },
  created() {
    this._globalErrorHandler = (payload) => {
      this.showDetails = true;
      this.title = payload.title;
      this.message = payload.message;
      this.error = payload.error;
      this.show();
      throw payload.error;
    };
    this.EventBus.$on("GLOBAL_ERROR", this._globalErrorHandler);
  },
  beforeUnmount() {
    this.EventBus.$off("GLOBAL_ERROR", this._globalErrorHandler);
  },
};
</script>
